<template>
  <div class="tooltip-box">
    <slot />
    <div
      class="tooltip"
    >
      <span
        class="text"
      >{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.tooltip-box {
  position: relative;
  display: inline-block;
}

.tooltip-box:hover .tooltip{
  opacity: 1;
}

.tooltip {
  padding: 6px 7px;
  width: 202px;
  right: 2px;

  opacity: 0;
  transition: opacity .4s;

  position: absolute;
  z-index: 1;

  background: #1F85D7;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 120%;
  color: #F3F3F3;
}

.text::after {
  content: " ";
  position: absolute;
  bottom: 100%;
  transform: rotate(180deg);
  left: 95%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #1F85D7 transparent transparent transparent;
}
</style>
